module.exports = __webpack_public_path__ + "media/logo/logo_goertek-e29d1bae.png";